exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-page {\n    /* background-color: #31a8f7; */\n    position:relative;\n    /* color: #000; */\n    /* transform:skew(0deg,2deg); */\n    \n\n}\n.post-page-inner {\n    padding-top:45px;\n    padding-bottom:30px;\n    /* transform: skew(0deg, -2deg); */\n}\nh1, h2, h3, h4, h5 {\n    font-family: 'Special Elite', cursive;\n    color: #FC4B0A;\n}\n.history-block {\n    margin-bottom: 30px;\n}\nh5 {\n    margin: 0;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/history-post/history-post.component.css
// module id = ../../../../../src/app/history-post/history-post.component.css
// module chunks = main